import { createWebHistory, createRouter } from "vue-router";

import Admin from '@/components/AdminPage';
import Callback from '@/components/CallbackPage';
import Content from '@/components/ContentPage';

const routes = [
  {
    path: '/',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  },
  {
    path: '/content',
    name: 'Content',
    component: Content
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
